import React from 'react';
import { Link } from 'react-router-dom';
import './BecomePremiumInvite.css'; // Import the CSS file for styles

const BecomePremiumInvite = ({ message = "Premium members get exclusive access to this feature." }) => {
    return (
        <div className="shimmer gold-container">
            <img 
                style={{ width: '35px', paddingRight: '5px' }} 
                src={require('../images/crown.png')} 
                alt="Icon" 
            />
            <span>{message}</span>
            <Link style={{ textDecoration: 'none' }} to="/Shop">
                Learn more about upgrading!
            </Link>
        </div>
    );
};

export default BecomePremiumInvite;